<template>
  <div class="p-6">
    <div class="benefit-card box rounded-xl shadow-lg my-2 p-4" v-for="(data,key) in problem" :key="key">
      <div class="flex flex-col">
        <h5 class="text-theme-1 text-base font-medium">{{data.name}}</h5>
        <div class="text-theme-37 flex items-center flex-wrap" v-for="(list,key_2) in data.list" :key="key_2">
          &emsp;-&emsp;{{list.desc}} 
           &emsp; &emsp;<div class="p-1 m-1 border border-theme-39 text-theme-37 rounded-md" v-if="list.name">{{list.name}}</div>
        </div>

      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
const props = defineProps({
  information: Object,
});
const problem = computed(() => {
  const problemObj = {prob_housing:"ด้านที่อยู่อาศัย",
        prob_health:"ด้านสุขภาพอนามัย",
        prob_education:"ด้านการศึกษา",
        prob_occupation:"ด้านการมีงานทำและมีรายได้",
        prob_family:"ด้านครอบครัว",
        prob_violence:"ด้านความรุนแรงในครอบครัว/สังคม",
        prob_human_trafficking:"ด้านการเป็นผู้เสียหายจากการค้ามนุษย์",
        prob_accesibility:"ด้านการเข้าไม่ถึงสิทธิและความเป็นธรรมในสังคม",
        prob_others:"ด้านสภาพปัญหาสังคมอื่นๆ "
      }
  let result = []
  Object.keys(problemObj).forEach(element => {
    if((props.information[element] ?? false) &&  (props.information[element]?.length > 0)){
      result.push({
        name: problemObj[element],
        list: props.information[element]
      })
    }
  });

  return result
});
</script>

<style lang="scss" scoped>
.benefit-card {
  position: relative;
  padding-left: 2rem;
  &::before {
    content: "";
    background-color: #15286c;
    width: 10px;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    border-top-left-radius: 0.75rem;
    border-bottom-left-radius: 0.75rem;
  }
}
</style>
